import { Pipe, PipeTransform } from '@angular/core';
import utf8 from 'utf8';

@Pipe({ name: 'utf8Decode' })
export class UTF8DecodePipe implements PipeTransform {
  transform(value: string): string {
    return utf8.decode(value);
  }
}